<template>
  <div id="navLocalComp">
    <div>
      <button class="nav_item" @click="toAll">{{all}}</button>
      <img src="../assets/icon-next.png">
      <span v-if="id" class="nav_item active" disabled>{{id}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navLocalComp',
  data: function () {
    return {
    }
  },
  created: function () {
  },
  components: {
  },
  props: {
    all: {
      type: String,
      required: true
    },
    id: {
      type: String,
      default: function () { return null }
    },
    toAll: {
      type: Function,
      required: true
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

#navLocalComp {
  margin: 32px 32px 0 32px;
  display: -webkit-flex;
  display: flex;
  justify-content: flex-start;
}
.nav_item {
  object-fit: contain;
  font-size: 22px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  color: #ff8200;
  border: none;
  background: none;
}
#navLocalComp > div > img {
  text-align: right;
  margin-left: 24px;
  margin-right: 24px;
}
.active {
  font-weight: 400;
}
.active:active, .active:hover {
  opacity: 1;
}
button:active, button:hover {
  opacity: 0.5;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
}
@media screen and (max-width: 320px){
}

</style>
